import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import { setup } from './utils/boot'
import routerProduction from './router/production'
import Toast, { PluginOptions } from 'vue-toastification'

import 'vue-toastification/dist/index.css'

import '@/assets/css/tailwind.css'
import '@/assets/css/fonts.css'
import '@/assets/css/base.css'

const options: PluginOptions = {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true
}

setup({
  onProduction: () => {
    createApp(App)
      .use(routerProduction)
      .use(createPinia())
      .use(Toast, options)
      .mount('#app')
  },
  onDevelopment: () => {
    createApp(App)
      .use(router)
      .use(createPinia())
      .use(Toast, options)
      .mount('#app')
  }
})
